import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const NavigationSideBar = function (
  {
    title,
    route,
    children,
    boldItem,
    onNavigate,
  }
) {
  const activeChild = useMemo(() => {
    if (!children) {
      return null
    }
    if (!Array.isArray(children)) {
      return children.props?.route === window.location.pathname ? children : null
    }
    return children && children.find((child) => {
      if (!child) {
        return null
      }
      if (child.props?.route === window.location.pathname) {
        return child
      }
      return null
    })
  }, [children])

  const [collapsed, setCollapsed] = useState(false)

  if (boldItem) {
    // render just the header but actually link to a route
    return <div className="nav-sidebar-item-group nav-sidebar-item-group-collapsed">
      <div
        className="nav-sidebar-item nav-sidebar-item-title"
        onClick={() => onNavigate(route)}
      >
        {title}
        <div
          className="nav-sidebar-item-expand-icon"
        />
      </div>
    </div>
  }
  const firstValidChild = Array.isArray(children) ? children.find((e) => e !== false)
    : children
  if (firstValidChild) {
    // render item with children
    let className = 'nav-sidebar-item-group ' + (collapsed ? 'nav-sidebar-item-group-collapsed' : '')
    if (activeChild) {
      className += ' nav-sidebar-item-group-active'
    }
    return <div className={className}>
      <div
        className="nav-sidebar-item nav-sidebar-item-title"
        onClick={() => {
          if (activeChild) {
            setCollapsed(!collapsed)
          } else {
            setCollapsed(false)
            onNavigate(firstValidChild.props.route)
          }
        }}
      >
        {title}
        <div
          className="nav-sidebar-item-expand-icon"
          onClick={(e) => {
            setCollapsed(!collapsed)
            e.stopPropagation()
          }}
        />
      </div>
      <div className="nav-sidebar-item-children">
        {children}
      </div>
    </div>
  }

  if (!route) {
    // no valid children and no route, we dont want to render just the header
    return null
  }

  // render the actual link
  let className = 'nav-sidebar-item nav-sidebar-item-link'
  let isActive = false
  if (window.location.pathname === route) {
    className += ' nav-sidebar-item-link-active'
    isActive = true
  }
  return <div className={className} onClick={() => !isActive && onNavigate(route)}>
    {title}
  </div>
}

NavigationSideBar.propTypes = {
  title: PropTypes.string.isRequired,
  route: PropTypes.string,
  boldItem: PropTypes.bool,
  onNavigate: PropTypes.func
}

export default NavigationSideBar
